export default __webpack_public_path__ + "static/media/Danielle.7a227bcb.jpg";